import CompactRegulationReviewCard from './CompactRegulationReviewCard.vue'
import RegulationReviewCard from './RegulationReviewCard.vue'

export const RegulationReviewPresentationMode = Object.freeze({
    DETAILED: 'detailed',
    COMPACT: 'compact',
})

const regulationReviewPresentationRegistry = Object.freeze({
    [RegulationReviewPresentationMode.DETAILED]: RegulationReviewCard,
    [RegulationReviewPresentationMode.COMPACT]: CompactRegulationReviewCard,
})

export const resolveRegulationReviewCard = mode => (
    regulationReviewPresentationRegistry[mode]
    || regulationReviewPresentationRegistry[RegulationReviewPresentationMode.DETAILED]
)

export default regulationReviewPresentationRegistry
